module.exports = __webpack_public_path__ + "static/youtube_solid-9f562b6d52d4701cd5745320b4c85edf.png";